import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

// 预览的凭证列表信息通过组件间传值input
// 证件的相关操作通过此service操作

interface IHttpResponse {
  error_code: number;
  error_msg: string;
  data: any;
}

interface IDeleteGuideImage {
  reservation_code: string;
  id: number;
}

interface IEditGuideAuditingStatus {
  reservation_code: string;
  status: number;
}

interface IGetGuideAuditingImages {
  reservation_code: string;
}

interface IGetRelateGuestList {
  page: number;
  page_size: number;
  reservation_order_code: string;
}

interface IRelateClientToReservation {
  client_id: number;
  guide_auditing_image_id: number;
}

interface IAddGuideImage {
  reservation_code: string;
  image: string;
}

const DELETE_GUIDE_IMAGE_API = '/api/reservation/delete_guide_image';
const EDIT_GUIDE_AUDITING_STATUS_API =
  '/api/reservation/edit_guide_auditing_status';
const GET_GUIDE_AUDITING_IMAGES_API = '/api/reservation/guide_auditing_images';
const GET_RELATED_GUEST_LIST_API = '/api/client/list';
const RELATE_CLIENT_API = '/api/reservation/relate_client';
const ADD_GUIDE_IMAGE_API = '/api/reservation/add_guide_image';

@Injectable()
export class ViewVoucherService {
  constructor(private http: HttpClient) {}

  /** 删除审核图片 */
  deleteGuideImage(params: IDeleteGuideImage) {
    return this.http.post(
      DELETE_GUIDE_IMAGE_API,
      params
    ) as Observable<IHttpResponse>;
  }

  /** 编辑审核状态 */
  ediGuideAuditingStatus(params: IEditGuideAuditingStatus) {
    return this.http.post(
      EDIT_GUIDE_AUDITING_STATUS_API,
      params
    ) as Observable<IHttpResponse>;
  }

  /** 获取入住指南图片列表 */
  getGuideAuditingImages(params: IGetGuideAuditingImages) {
    const query = new HttpParams().append(
      'reservation_code',
      `${params.reservation_code}`
    );
    return this.http.get(GET_GUIDE_AUDITING_IMAGES_API, {
      params: query,
    }) as Observable<IHttpResponse>;
  }

  /** 获取订单的房客列表 */
  getRelatedGuestList(params: IGetRelateGuestList) {
    const query = new HttpParams()
      .append('page', `${params.page}`)
      .append('page_size', `${params.page_size}`)
      .append('reservation_order_code', `${params.reservation_order_code}`);
    return this.http.get(GET_RELATED_GUEST_LIST_API, {
      params: query,
    }) as Observable<IHttpResponse>;
  }

  /** 入住凭证图片关联到房客 */
  relateClient(params: IRelateClientToReservation) {
    return this.http.post(
      RELATE_CLIENT_API,
      params
    ) as Observable<IHttpResponse>;
  }

  /** 添加审核照片 */
  addGuideImage(params: IAddGuideImage) {
    return this.http.post(
      ADD_GUIDE_IMAGE_API,
      params
    ) as Observable<IHttpResponse>;
  }

  relateClientToReservation (params) {
    return this.http.post(
      '/api/reservation/reservation_add_client',
      params
    ) as Observable<any>;
  }
}
